import { combineReducers } from '@reduxjs/toolkit'
import footer from './footerSlice';

const reducer = combineReducers({
   footer
})

export default reducer